import { createSlice } from "@reduxjs/toolkit";
import {
  forgotPassword,
  getAdminUserDetails,
  login,
  resetNewPassword,
  resetPassword,
  signUp,
  validateUUID,
  verifyOtp,
  verifyEmail,
  resendVerificationLink,
  checkVerificationStatus,
  saveCompanyInfo,
} from "../actions/authSlice";

const initialState = {
  isLoggedIn: false,
  loading: false,
  isPermissionChecked: false,
  isLoading: false,
  signUpUser: {},
  authUser: {},
  accountType: null,
  adminPermissions: [],
  isGettingUserDetails: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsPermissionChecked: (state, action) => {
      state.isPermissionChecked = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signUp.pending, (state) => {
        state.isLoading = true;
        state.isLoggedIn = false;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data } = action.payload;
          state.signUpUser = data;
          localStorage.setItem("authUserId", data._id);
        }
      })
      .addCase(signUp.rejected, (state, action) => {
        state.isLoading = false;
      });
    builder
      .addCase(verifyEmail.pending, (state) => {
        // state.isLoading = true;
        // state.isLoggedIn = false;
      })
      .addCase(verifyEmail.fulfilled, (state, action) => {
        // state.isLoading = false;
        // const { success } = action.payload || {};
        // if (success) {
        //   const { data } = action.payload;

        //   const { role, accountType = "superadmin" } = data || {};
        //   state.authUser = data;
        //   state.isLoggedIn = true;
        //   state.accountType = accountType;
        //   state.adminPermissions = role?.permissions;
        //   // SET DATA IN LOCAL DB
        //   localStorage.setItem("authUser", JSON.stringify(data));
        //   localStorage.setItem("isLoggedIn", true);
        //   localStorage.setItem("accountType", accountType);
        // }
      })
      .addCase(verifyEmail.rejected, (state, action) => {
        state.isLoading = false;
      });
    builder
      .addCase(resendVerificationLink.pending, (state) => {
        state.isLoading = true;
        state.isLoggedIn = false;
      })
      .addCase(resendVerificationLink.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(resendVerificationLink.rejected, (state, action) => {
        state.isLoading = false;
      });
    builder
      .addCase(checkVerificationStatus.pending, (state) => {
        state.isLoading = true;
        state.isLoggedIn = false;
      })
      .addCase(checkVerificationStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data } = action.payload;

        //   const { role, accountType = "superadmin" } = data || {};
        //   state.authUser = data;
        //   state.isLoggedIn = true;
        //   state.accountType = accountType;
        //   state.adminPermissions = role?.permissions;
        //   // SET DATA IN LOCAL DB
          localStorage.setItem("authUser", JSON.stringify(data));
          localStorage.setItem("isLoggedIn", true);
        }
      })
      .addCase(checkVerificationStatus.rejected, (state, action) => {
        state.isLoading = false;
      });
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.isLoggedIn = false;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data } = action.payload;

          const { role, accountType = "superadmin" } = data || {};
          state.authUser = data;
          state.isLoggedIn = true;
          state.accountType = accountType;
          state.adminPermissions = role?.permissions;
          // SET DATA IN LOCAL DB
          localStorage.setItem("authUser", JSON.stringify(data));
          localStorage.setItem("isLoggedIn", true);
          localStorage.setItem("accountType", accountType);
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(forgotPassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.isLoading = false;
      });
    builder
      .addCase(saveCompanyInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveCompanyInfo.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(saveCompanyInfo.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(verifyOtp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(resetPassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(validateUUID.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(validateUUID.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(validateUUID.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(resetNewPassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resetNewPassword.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(resetNewPassword.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getAdminUserDetails.pending, (state) => {
        state.isLoading = true;
        state.isGettingUserDetails = true;
      })
      .addCase(getAdminUserDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isGettingUserDetails = false;
        const { success } = action.payload || {};
        if (success) {
          const { data } = action.payload || {};
          const { role, accountType } = data || {};
          state.authUser = data;
          state.adminPermissions = role?.permissions;
          state.accountType = accountType;

          localStorage.setItem("authUser", JSON.stringify(data));
          localStorage.setItem("isLoggedIn", true);
          localStorage.setItem("accountType", accountType);
        }
      })
      .addCase(getAdminUserDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isGettingUserDetails = false;
      });
  },
});

export const { setIsPermissionChecked } = authSlice.actions;

export default authSlice.reducer;
